import Pressable from '@/components/motion/pressable';
import { cn } from '@/lib/utils';

interface SenderSelectRowProps {
	title: string;
	meaning?: string;
	selected: boolean;
	onSelect: () => void;
}

export default function SenderSelectRow({ title, meaning, selected, onSelect }: SenderSelectRowProps) {
	return (
		<Pressable
			role='button'
			tabIndex={0}
			onClick={onSelect}
			className={cn(
				'flex min-h-11 w-full items-start gap-3 rounded-xl border px-3 py-2.5 text-left active:bg-accent/30',
				selected ? 'border-primary bg-primary/5' : 'border-border/60 bg-card/40',
			)}
		>
			<span
				className={cn(
					'mt-1 size-4 shrink-0 rounded-full border-2',
					selected ? 'border-primary bg-primary' : 'border-muted-foreground',
				)}
				aria-hidden
			/>
			<div className='min-w-0 flex-1'>
				<p className='text-[15px] font-medium'>{title}</p>
				{meaning ? <p className='text-[13px] text-muted-foreground'>{meaning}</p> : null}
			</div>
		</Pressable>
	);
}
